import { HiddenElementsScope } from '../../hiddenElementsScope';
import type { HiddenElement } from '../../hiddenElementsTypes';

export interface HiddenElementsSectionDispatchProps {
  previewComponentOnStage: (element: HiddenElement) => Promise<void>;
  stopPreviewComponentOnStage: (element: HiddenElement) => void;
  unhideComponent: (element: HiddenElement) => Promise<void>;
}

export const mapDispatchToProps = (
  scope: HiddenElementsScope,
): HiddenElementsSectionDispatchProps => {
  const { privateApi, store } = scope;

  return {
    previewComponentOnStage: privateApi.previewComponentOnStage,
    stopPreviewComponentOnStage: privateApi.stopPreviewComponentOnStage,
    unhideComponent: async (element: HiddenElement): Promise<void> => {
      store.optimisticallyRemoveHiddenElement(element.compId);
      await privateApi.unhideComponent(element);
    },
  };
};
